import React from 'react'
import { Space, Switch, Table } from 'antd';

function MapTable({ columns, data }) {
    const expandedRowRender = (props) => {
        // console.log(props)
        return <Table dataSource={data?.filter(data => {
            if (props?.state === data?.state) {
                return data
            }
        })?.sort((a, b) => b?.onboard - a?.onboard)} columns={columns} pagination={false} scroll={{
            y: 500,
            x: 1000
        }} />;
    };

    const groupData = () => {
        const result = data.reduce((acc, curr) => {
            const existingState = acc.find(item => item.state?.toString()?.toLowerCase() === curr.state?.toString()?.toLowerCase());
            if (existingState) {
                for (let key in curr) {
                    if (key !== 'state' && key !== 'city') {
                        existingState[key] = String(Number(existingState[key]) + Number(curr[key]));
                    }
                }
            } else {
                const newState = { state: curr.state, city: 'All' };
                for (let key in curr) {
                    if (key !== 'state' && key !== 'city') {
                        newState[key] = curr[key];
                    }
                }
                acc.push(newState);
            }
            return acc;
        }, []);
        return result
    }
    return (


        <div>
            <Table className='table-map-state'
                columns={columns}
                expandable={{
                    expandedRowRender,
                    defaultExpandedRowKeys: ['0'],
                }}
                scroll={{
                    y: 500,
                    x: 1000
                }}
                dataSource={groupData(data)?.map((data, id) => {
                    return { ...data, key: id }
                })?.sort((a, b) => b?.onboard - a?.onboard)}
            />

        </div>
    )
}

export default MapTable
